import { render, staticRenderFns } from "./timetable-date.vue?vue&type=template&id=b23f2ac0&lang=pug&"
import script from "./timetable-date.vue?vue&type=script&lang=js&"
export * from "./timetable-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports